import React from "react";
import { Cake } from "lucide-react";
import { brand } from "../mock/mock";

const Marquee = () => {
  const items = Array.from({ length: 10 });
  return (
    <div className="w-full bg-[#9D184C] text-white overflow-hidden py-3 select-none">
      <div className="marquee-track">
        {items.map((_, i) => (
          <span
            key={i}
            className="font-body font-semibold tracking-[0.35em] text-sm md:text-base uppercase mx-6 inline-flex items-center gap-6"
          >
            {brand.marquee}
            <Cake size={16} className="text-white/70" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
